import React, { useEffect } from "react";

import "./cup.scss";
import { observer } from "mobx-react-lite";
import CenturyCup from "./century_cup/century_cup";
import GameCalendar from "./game_calendar/game_calendar";
import CupNews from "./news/news";
import CupScoreTableBlock from "./score_table_block/score_table_block";

import betcity_logo from "../../assets/images/betcity_logo.png";
import Footer from "../../components/footer/footer";

function CupPage() {
	useEffect(() => {
		document.title = "БЕТСИТИ Кубок Столетия";
	});

	return (
		<>
			<div className="cup_content_wrapper">
				<div className="content">
					<div className="century_cup_wrapper">
						<CenturyCup></CenturyCup>
					</div>
					<div className="game_calendar_wrapper">
						<GameCalendar></GameCalendar>
					</div>
					<div className="news_wrapper">
						<CupNews></CupNews>
					</div>
					<div className="score_table_wrapper">
						<CupScoreTableBlock></CupScoreTableBlock>
					</div>

					<div className="sponsor_block_wrapper">
						<div className="sponsor_block">Титульный спонсор</div>
						<div className="sponsor_logo">
							<img src={betcity_logo} alt=""></img>
						</div>
					</div>
					<Footer></Footer>
				</div>
			</div>
		</>
	);
}

export default observer(CupPage);
